module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modals"
  }, [_c('el-dialog', {
    attrs: {
      "width": "40%",
      "title": _vm.socialPostModalTitle,
      "visible": _vm.socialPostModal,
      "center": true,
      "close-on-click-modal": false,
      "top": _vm.defaultTop
    },
    on: {
      "update:visible": function($event) {
        _vm.socialPostModal = $event
      }
    }
  }, [_c('div', {
    staticClass: "info"
  }, [_c('el-tooltip', {
    staticClass: "item",
    attrs: {
      "effect": "dark",
      "content": "Help",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "el-icon-info",
    attrs: {
      "type": "info"
    },
    on: {
      "click": function($event) {
        _vm.innerInfoDialogIsVisible = true
      }
    }
  })])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "width": "40%",
      "center": true,
      "title": "How to",
      "visible": _vm.innerInfoDialogIsVisible,
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.innerInfoDialogIsVisible = $event
      }
    }
  }, [_c('el-carousel', {
    attrs: {
      "interval": 4000,
      "type": "card",
      "height": "200px",
      "initial-index": 0,
      "autoplay": false,
      "trigger": "click"
    }
  }, _vm._l((_vm.instructions), function(instruction, index) {
    return _c('el-carousel-item', {
      key: index
    }, [_c('h2', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('strong', [_vm._v("Step " + _vm._s(index + 1))])]), _vm._v(" "), _c('h2', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(instruction))])])
  }), 1)], 1), _vm._v(" "), (_vm.socialPostModal) ? _c('social-posts-container', {
    attrs: {
      "channels": _vm.socialChannels
    },
    on: {
      "close": _vm.closeSocialPostModal
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-14c74b07","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/modals/ModalContainer.vue
// module id = 3149
// module chunks = 3